import { clearAuthCookies, getAuthToken } from "../Auth/authCookie";

// Несколько параллельных запросов могут словить 401 одновременно (страница
// обычно делает сразу несколько вызовов на монтировании). Без этого флага
// каждый из них независимо читал бы window.location.href и строил свой
// собственный redirect — второй вызов подхватывал бы URL, уже переписанный
// первым (с ?redirect=...), и кодировал его ещё раз поверх, превращая
// %3A в %253A. Флаг гарантирует, что реально сработает только первый вызов.
let isRedirectingToLogin = false;

// Общая точка входа для любого места в приложении, которое решает, что
// пользователя нужно отправить на логин с возвратом на текущую страницу.
// Гарантирует, что при нескольких одновременных 401 (или вызове из Layout
// параллельно с вызовом из AdvancedFetch) реально сработает только первый —
// иначе второй вызов подхватил бы уже переписанный window.location.href
// (с ?redirect=...) и закодировал бы его ещё раз поверх.
export function redirectToLoginWithReturn() {
    if (isRedirectingToLogin) return;
    isRedirectingToLogin = true;

    const basicUrl = window.location.protocol === 'https:' ? process.env.REACT_APP_BASIC : process.env.REACT_APP_LOCAL_BASIC;
    const currentUrl = window.location.href;
    const loginUrl = `${basicUrl}/login?redirect=${encodeURIComponent(currentUrl)}`;

    window.location.href = loginUrl;
}

function clearAuthCookieAndRedirectToLogin() {
    clearAuthCookies();

    redirectToLoginWithReturn();
}

const AUTH_BOOTSTRAP_PATHS = [
    '/auth/magic-link/',
    '/auth/login',
    '/auth/sign-up',
    '/auth/available-to-login',
    '/forgot-password',
    '/phone-verification/',
    '/user/email-verify',
    '/user/email-resend',
];

function isAuthBootstrapRequest(input: Parameters<typeof fetch>[0]): boolean {
    const url = input instanceof Request ? input.url : String(input);
    return AUTH_BOOTSTRAP_PATHS.some((path) => url.includes(path));
}

export function AdvancedFetch(...options: Parameters<typeof fetch>) {
    return fetch(...options)
        .then(async res => {
            const contentType = res.headers.get("content-type") || ''

            if (res.status === 401) {
                if (!isAuthBootstrapRequest(options[0])) {
                    clearAuthCookieAndRedirectToLogin();
                }
                throw new Error('Unauthorized');
            }
            if (res.status === 404) {
                throw new Error('404 Page Not Found')
            }
            if (res.status === 422) {
                const message = await res.json().then((result) => {
                    const firstFieldError = result?.errors && Object.values(result.errors)[0]
                    return (Array.isArray(firstFieldError) ? firstFieldError[0] : null) || result.message
                })
                throw Object.assign(new Error(message), { status: 422 })
            }
            if (res.status === 204) {
                return null
            }
            if (res.status === 500) {
                throw new Error('Internal Server Error')
            }
            if (res.status >= 400) {
                throw new Error(res.statusText)
            }

            if (contentType.startsWith('application/json')) {
                return res.json()
            }
            if (contentType.startsWith('text/plain')) {
                return res.text()
            }
            if (contentType.startsWith('text/html')) {
                return res.text()
            }

            return res
        })
}

const token = {
    toString: function() {
        return `Bearer ${getAuthToken()}`;
    }
};

export const requestOptions = {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': token
    }
};
